module.exports = __webpack_public_path__ + "static/media/aboutus.d9f1d4a3.png";